import { environment } from '../../environments/environment';

interface DataLayerObject {
  event: string;
  [key: string]: any;
}

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const pushToDataLayer = (dataLayer: DataLayerObject): void => {
  try {
    if (window.dataLayer || window.dataLayer.length >= 0) {
      window.dataLayer.push(dataLayer);
    }
  } catch (e) {
    console.log(e);
  }
};

// Yeni para çekme (cashout) fonksiyonu
export const pushCashOutEvent = (value: number, currency: string, transactionId: number): void => {
  pushToDataLayer({
    developer_id: { '000000': true },
    gtm: {
      uniqueEventId: Date.now(), // Dinamik olarak oluşturulmuş benzersiz ID
      start: Date.now(), // Dinamik olarak oluşturulmuş başlangıç zamanı
    },
    event: 'cashOut_complete',
    value: value,
    currency: currency,
    transaction_id: transactionId,
  });
};

// Mevcut hesap yükleme (deposit) fonksiyonunu düzenleme
export const pushTopUpDepositEvent = (value: number, currency: string, transactionId: number): void => {
  pushToDataLayer({
    developer_id: { '000000': true },
    gtm: {
      uniqueEventId: Date.now(), // Dinamik olarak oluşturulmuş benzersiz ID
      start: Date.now(), // Dinamik olarak oluşturulmuş başlangıç zamanı
    },
    event: 'topUp_deposit',
    value: value,
    currency: currency,
    transaction_id: transactionId,
  });
};
